/* eslint-disable react/static-property-placement */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, Fields, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@getgrover/ui';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import { LayoutComponent_Text as LayoutComponentText } from 'ggApp/modules/layout';
import ggForm, {
    FormComponent_Select as FormComponentSelect,
    FormComponent_Input as FormComponentInput,
    FormComponent_InputDoubled as FormComponentInputDoubled,
} from 'ggApp/modules/form';
import { Translator } from 'ggApp/modules/translator/components';

import { AuthComponent_PhoneVerification as AuthComponentPhoneVerification } from 'ggApp/modules/auth';
import * as ggAddressActions from '../../actions';

import { Form, Wrap } from './styles';

const { phoneVerificationValidation, requiredValidation, cityValidation } = ggForm.validations;
const FormName = 'checkoutCreateAddress';

@withDeviceInfo
@connect(null, (dispatch) => ({
    addressActions: bindActionCreators(ggAddressActions, dispatch),
}))
@reduxForm({
    getFormState: (state) => ggForm.selectors.reduxForm(state),
    form: FormName,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate: (values) => {
        const errors = {};

        errors.country_id = requiredValidation(values.country_id);
        errors.address1 = requiredValidation(values.address1);
        errors.address2 = requiredValidation(values.address2);
        errors.zipcode = requiredValidation(values.zipcode);
        errors.city = cityValidation(values.city);
        errors.phone = phoneVerificationValidation(values.phone || {});

        return errors;
    },
})
export default class CheckoutCreateAddressForm extends Component {
    static propTypes = {
        countryList: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    render() {
        const {
            modal,
            addressActions,
            updatePhone,
            confirmPhone,
            countryList,
            authFetching,
            authPhoneVerification,
            handleSubmit,
            submitting,
            initialValues,
            error,
            disableCountry,
            userDevice,
        } = this.props;
        const isMobile = userDevice === 'mobile';
        const zipcodeParser = (code) => {
            const isNl = countryList.some((i) => i.id === 166);

            if (!isNl) {
                return code;
            }

            return code.replace(/([0-9]+)([A-Za-z])/, '$1 $2');
        };
        return (
            <Form id={FormName} onSubmit={handleSubmit(addressActions.add)} modal={modal}>
                <Wrap>
                    <Field
                        id={`${FormName}CountryIdSelect`}
                        disabled={disableCountry}
                        reqMark
                        globalError={error}
                        name="country_id"
                        type="select"
                        label="FORM_LABEL_COUNTRY"
                        data={countryList}
                        component={FormComponentSelect}
                    />
                    <Fields
                        reqMark
                        globalError={error}
                        ids={[`${FormName}Address1Input`, `${FormName}Address2Input`]}
                        names={['address1', 'address2']}
                        labels={['FORM_LABEL_STREET', 'FORM_LABEL_HOUSE']}
                        flexes={!isMobile ? [0.75, 0.25] : [0.6, 0.4]}
                        component={FormComponentInputDoubled}
                    />
                    <Field
                        id={`${FormName}AdditionalInfo`}
                        withTouch
                        name="additional_info"
                        type="text"
                        label="FORM_LABEL_ADDITIONAL"
                        component={FormComponentInput}
                    />
                    <Fields
                        reqMark
                        globalError={error}
                        ids={[`${FormName}ZipcodeInput`, `${FormName}CityInput`]}
                        names={['zipcode', 'city']}
                        labels={['FORM_LABEL_POSTCODE', 'FORM_LABEL_CITY']}
                        flexes={!isMobile ? [0.25, 0.75] : [0.4, 0.6]}
                        component={FormComponentInputDoubled}
                        parse={zipcodeParser}
                    />

                    {!!error && (
                        <LayoutComponentText mini error>
                            {error}
                        </LayoutComponentText>
                    )}
                </Wrap>

                {!modal && !initialValues.phone.isVerified && (
                    <AuthComponentPhoneVerification
                        namesUpdate={['phone.code', 'phone.number', 'phone.isVerified']}
                        namesConfirm={['phone.isVerified', 'phone.verificationCode']}
                        authPhoneVerification={authPhoneVerification}
                        formName={FormName}
                        updatePhone={updatePhone}
                        confirmPhone={confirmPhone}
                        authFetching={authFetching}
                    />
                )}

                {!modal &&
                    initialValues.phone.isVerified &&
                    authPhoneVerification.progress === false && (
                        <LayoutComponentText>
                            <Translator tk="PHONE_VERIFICATION_SUCCESS" />
                        </LayoutComponentText>
                    )}

                <LayoutComponentText mini lightWeight>
                    <Translator tk="FORM_MANDATORY_FIELDS" />
                </LayoutComponentText>

                <Button type="submit" primary fullWidth centred loading={submitting}>
                    <Translator tk="CONTINUE" />
                </Button>
            </Form>
        );
    }
}
